import $ from 'jquery'

const FieldTypes = (($) => {
	return {
		SingleLineText: 1,
		Paragraph: 2,
		Email: 3,
		Dropdown: 4,
		MultipleChoice: 5,
		Checkboxes: 6,
		State: 7,
		SectionBreak: 8,
		DateInput: 9,		
		Phone: 10,
	}
})($)


export default FieldTypes
